function debounce(func, wait, immediate) {
  var timeout = void 0;
  return function () {
    var context = this,
        args = arguments;

    var later = function later() {
      timeout = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
}

module.exports = debounce;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/debounce.js
// module id = 291
// module chunks = 0 1 2